import api from "../adapter/base";
import { useQuery,useMutation } from "react-query";

const product = (id) => {
  return api.get(`products/${id}`);
};
// list products that are under categories
const products = async (category_id, page = 1, name, paginate) => {
  const res = await api.get(
    `${category_id ? `categories/${category_id}/` : ``}products${
      page ? `?page=${page}` : ``
    }${name ? `&name=${name}` : ``}${paginate ? `&paginate=${paginate}` : ``}`
  );
  return res.data;
};


// used to activate and deactivate a product
const activateDeactivate = (product) => {
  const updatedProductStatus = { is_active: !product.is_active ? 1 : 0 };
  return api.put(`products/${product?.id}`, updatedProductStatus);
};

export const useProduct = (id) => {
  return useQuery(["product", id], () => product(id), {
    select: (data) => {
      const imagepaths = data.data.data.image_paths;
      return imagepaths;
    },
  });
};

export const useProducts = (category_id, page, name, paginate) => {
  return useQuery(["products", category_id, page, name, paginate], () =>
    products(category_id, page, name, paginate)
  );
};

// used to update product status
export const useActivateDeactivateProduct = () => {
  return useMutation(activateDeactivate);
};